import { render, staticRenderFns } from "./CustomerGenderDelete.vue?vue&type=template&id=78a975db"
import script from "./CustomerGenderDelete.vue?vue&type=script&lang=js"
export * from "./CustomerGenderDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports